import { useTranslation } from "react-i18next";
import { IBatch } from "../../../../@types/API/IBatches";
import { getBatchClassification } from "../../../../utils/batches/getBatchClassification";

type Props = {
  code: string;
  batch?: Partial<Pick<IBatch, "batch_label" | "batch_stamp">>;
};

export function BatchIdentification({ code, batch }: Props) {
  const { i18n } = useTranslation();
  const classification = getBatchClassification(batch, i18n.language);

  return (
    <>
      <span>{code}</span>
      {classification && (
        <span className="cattleMap_batchClassification">{classification}</span>
      )}
    </>
  );
}
